import { render } from "./PedidosTable.vue?vue&type=template&id=16d928d1&ts=true"
import script from "./PedidosTable.vue?vue&type=script&lang=ts"
export * from "./PedidosTable.vue?vue&type=script&lang=ts"

import "./PedidosTable.vue?vue&type=style&index=0&id=16d928d1&lang=css"

import exportComponent from "F:\\Projetos 2024\\e-logDash\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__